import React from "react";
import { Typography, Box } from "@mui/material";
import { BannerContainer } from "./Banner.styled";
import { BookAppointmentStrip } from "components";

const Banner = ({ banner, bannerImg, bannerSize }) => {
  // अगर banner array है तो उसे map कर दो
  if (Array.isArray(banner)) {
    return (
      <>
        <BannerContainer
          image={bannerImg}
          px={{ md: 10, xs: 5 }}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Box mb={{ md: 8, xs: 3 }}>
            {banner.map((item, index) => (
              <Typography
                key={index}
                component="h2"
                fontSize={{
                  md: bannerSize && bannerSize[index] ? bannerSize[index] : "2.125rem",
                  xs:
                    bannerSize && bannerSize[index]
                      ? bannerSize[index].split("rem")[0] / 1.75 + "rem"
                      : "2.375rem",
                }}
                fontWeight={
                  bannerSize && bannerSize[index] !== "2.375rem" ? "bold" : "normal"
                }
                textTransform={
                  bannerSize && bannerSize[index] === "2.375rem" ? "uppercase" : "unset"
                }
                mb={1}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </BannerContainer>

        <Box mb={{ md: "10rem", xs: "2.5rem" }}>
          <BookAppointmentStrip />
        </Box>
      </>
    );
  }

  // अगर banner string है तो split करो "||" पर
  if (typeof banner === "string") {
    const parts = banner.split("||").map((part) => part.trim());

    return (
      <>
        <BannerContainer
          image={bannerImg}
          px={{ md: 10, xs: 5 }}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Box mb={{ md: 8, xs: 3 }}>
            <Typography
              component="h1"
              fontSize={{ md: "2.125rem", xs: "2.25rem" }}
              fontWeight={
                bannerSize && bannerSize[0] !== "2.375rem" ? "bold" : "normal"
              }
              textTransform={
                bannerSize && bannerSize[0] === "2.375rem" ? "uppercase" : "unset"
              }
              mb={1}
            >
              {parts[0] || "Heading not found"}
            </Typography>

            <Typography
              component="p"
              fontSize={{
                md: "1.5rem",
                xs: "1rem",
              }}
              fontWeight="normal"
              mt={1}
            >
              {parts[1] || "Paragraph not found"}
            </Typography>
          </Box>
        </BannerContainer>

        <Box mb={{ md: "10rem", xs: "2.5rem" }}>
          <BookAppointmentStrip />
        </Box>
      </>
    );
  }

  // Agar banner kuch bhi nahi to null return karo
  return null;
};

export default Banner;
